import axios from './axiosInstance';



const setDefaults=() => {
    axios.defaults.headers.common['Content-Type']='application/x-www-form-urlencode';
    axios.defaults.headers.common['Accept']='application/json';
};


const AddProduct=({token,payload}) => {
    setDefaults()
    return new Promise((resolve,reject) => {
        axios.defaults.headers.common={'auth-token': `${token}`}
        axios.post(`/products/add`,payload)
            .then(response => resolve(response.data))
            .catch((error) => {reject(error.response)})
    })
}

const DeleteProduct=({token,payload: {_id}}) => {
    setDefaults()
    return new Promise((resolve,reject) => {
        axios.defaults.headers.common={'auth-token': `${token}`}
        axios.delete(`/products/${_id}`,)
            .then(response => resolve(response.data))
            .catch((error) => {reject(error.response)})
    })
}



const GetProduct=({token,_id, venue}) => {
    setDefaults()
    return new Promise((resolve,reject) => {
        axios.defaults.headers.common={'auth-token': `${token}`}
        axios.get(`/products/${_id}`,{venue})
            .then(response => resolve(response.data))
            .catch((error) => {reject(error.response)})
    })
}


const GetProducts=({token,venue}) => {
    setDefaults()
    return new Promise((resolve,reject) => {
        axios.defaults.headers.common={'auth-token': `${token}`}
        axios.post(`/products/`, {venue})
            .then(response => resolve(response.data))
            .catch((error) => {reject(error.response)})
    })
}

const GetProductOptions=({_id}) => {
    setDefaults()
    return new Promise((resolve,reject) => {
        axios.get(`/products/options/${_id}`)
            .then(response => resolve(response.data))
            .catch((error) => {reject(error.response)})
    })
}

const ReOrderProducts=({token,payload}) => {
    setDefaults()
    return new Promise((resolve,reject) => {
        axios.defaults.headers.common={'auth-token': `${token}`}
        axios.post(`/products/reorder/`,payload)
            .then(response => resolve(response.data))
            .catch((error) => {reject(error.response)})
    })
}

const TransferProduct=({token,payload}) => {
    setDefaults()
    return new Promise((resolve,reject) => {
        axios.defaults.headers.common={'auth-token': `${token}`}
        axios.post(`/products/transfer/`,payload)
            .then(response => resolve(response.data))
            .catch((error) => {reject(error.response)})
    })
}

const UnDeleteProduct=({token,_id}) => {
    setDefaults()
    return new Promise((resolve,reject) => {
        axios.defaults.headers.common={'auth-token': `${token}`}
        axios.patch(`/products/undelete/${_id}`,)
            .then(response => resolve(response.data))
            .catch((error) => {reject(error.response)})
    })
}


const UpdateProduct=({token,payload: {product}}) => {
    setDefaults()
    return new Promise((resolve,reject) => {
        axios.defaults.headers.common={'auth-token': `${token}`}
        axios.post(`/products/update/${product._id}`,product)
            .then(response => resolve(response.data))
            .catch((error) => {reject(error.response)})
    })
}

const UpdateProductLists=({token,data}) => {
    setDefaults()
    return new Promise((resolve,reject) => {
        axios.defaults.headers.common={'auth-token': `${token}`}
        axios.post(`/products/updateLists`,data)
            .then(response => resolve(response.data))
            .catch((error) => {reject(error.response)})
    })
}




export {
    AddProduct,
    DeleteProduct,
    GetProduct,
    GetProducts,
    GetProductOptions,
    ReOrderProducts,
    TransferProduct,
    UnDeleteProduct,
    UpdateProduct,
    UpdateProductLists
}


